import { render, staticRenderFns } from "./modalTraffictViolation.vue?vue&type=template&id=14588e03&scoped=true"
import script from "./modalTraffictViolation.vue?vue&type=script&lang=js"
export * from "./modalTraffictViolation.vue?vue&type=script&lang=js"
import style0 from "./modalTraffictViolation.vue?vue&type=style&index=0&id=14588e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14588e03",
  null
  
)

export default component.exports